module.exports = __webpack_public_path__ + "static/media/snowflakes.6e62b1a0.svg";